// @flow
import React from "react";
import { GlobalProvider } from "../common/GlobalContext";

import Elevate from "./Elevate";
import Agentology from "./Agentology";

type $Props = {
  tenant: string,
  theme: Object,
};

const PrivacyPolicy = ({ tenant, theme }: $Props) => {
  return (
    <GlobalProvider theme={theme}>
      {tenant === "agentology" ? <Agentology /> : <Elevate />}
    </GlobalProvider>
  );
};

export default PrivacyPolicy;
